export class Loop {
  private frameId = 0;
  private lastTime = 0;
  private running = false;
  private accumulator = 0;
  private elapsed = 0;
  private readonly fixedDelta = 1 / 60;

  constructor(
    private readonly update: (deltaSeconds: number, elapsedSeconds: number) => void,
    private readonly render: (alpha: number, elapsedSeconds: number) => void,
  ) {}

  start(): void {
    if (this.running) return;
    this.running = true;
    this.lastTime = performance.now();
    this.accumulator = 0;
    this.frameId = requestAnimationFrame(this.tick);
  }

  stop(): void {
    this.running = false;
    cancelAnimationFrame(this.frameId);
  }

  private readonly tick = (time: number) => {
    if (!this.running) return;
    const frameDelta = Math.min((time - this.lastTime) / 1000, 0.25);
    this.lastTime = time;
    this.accumulator += frameDelta;

    let steps = 0;
    while (this.accumulator >= this.fixedDelta && steps < 5) {
      this.elapsed += this.fixedDelta;
      this.update(this.fixedDelta, this.elapsed);
      this.accumulator -= this.fixedDelta;
      steps += 1;
    }
    if (steps === 5) this.accumulator = 0;

    this.render(this.accumulator / this.fixedDelta, this.elapsed);
    this.frameId = requestAnimationFrame(this.tick);
  };
}
